import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Left',  label: 'Left'  },
  { value: 'Right', label: 'Right' },
];

// OperatingSideLite is visible when:
//   Left hinges  + door type has right side lite  (ids 3, 4)
//   Right hinges + door type has left side lite   (ids 2, 4)
const shouldShowOperatingSideLite = (hingesValue, doorTypeId) =>
  (hingesValue === 'Left'  && [3, 4].includes(doorTypeId)) ||
  (hingesValue === 'Right' && [2, 4].includes(doorTypeId));

const DEFAULT = 'Left';

const Hinges = ({ value = { value: '', label: '' }, onChange, disabled = false, selectedDoor, onOperatingSideLiteVisible }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  // Re-evaluate visibility whenever door type changes
  useEffect(() => {
    onOperatingSideLiteVisible?.(shouldShowOperatingSideLite(selected, selectedDoor?.id));
  }, [selectedDoor?.id, selected]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    onOperatingSideLiteVisible?.(shouldShowOperatingSideLite(v, selectedDoor?.id));
  };

  return (
    <div className="a-container">
      <label htmlFor="SdHinges">Hinges</label>
      <select id="SdHinges" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Hinges;
